import "./services-cta.css";
import { FaArrowRight } from "react-icons/fa";

const ServicesCTA = () => {
  return (
    <section className="services-cta">
      <div className="services-cta__container">
        <div className="services-cta__content">
          <span className="services-cta__badge">Start Your Project</span>

          <h2 className="services-cta__title">
            Let’s Build Something <span>Exceptional</span>
          </h2>

          <p className="services-cta__subtitle">
            Partner with Oglitz to design, develop, and scale digital products
            that deliver real business impact.
          </p>

          <div className="services-cta__actions">
            <a
              href="/start-project#start-project-form"
              className="services-cta__btn-primary"
            >
              Start a Project <FaArrowRight />
            </a>

            <a href="/contact" className="services-cta__btn-secondary">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCTA;
